<template>
    <div>
        <div style="width:100%;height:10px;"></div>
        <div class="headInfo">
            <div @click="back"><<返回</div>
            <div>我的店铺</div>
            <div>
                <div @click="goMangerMyShop" class="mangerInfo">管理基本信息</div>
            </div>
        </div>
        <!--添加分类-->
        <div class="addClass">
            <div>
                添加产品分类
            </div>
            <div>
                <div class="outInputClass"><input maxlength="15" type="text" v-model="className" class="inputClass" placeholder="输入分类"/></div>
                <div class="confirmAdd" @click="confirmAdd">确认添加</div>
            </div>
            <div class="hasAddClass">
                <div class="classList" v-for="(item,index) in hasAddClassName" :key="index">
                    <div>{{item.name}}</div>
                    <div @click="deleteClassName(item.id)"><img src="../assets/images/images/listClose.png"></div>
                </div>
            </div>
            <div class="tips">
                <span>注：</span>
                <span>
                    以上设置的关键词将作为门店产品页的细分板块，若发布的宝贝文字中含有以上的关键词，将直接进入这个细分板块。
                </span>
            </div>
        </div>
        <div class="checkShopInfo">
            <div @click="goShopDetail">查看前台店铺效果</div>
        </div>
         <!-- 历史信息 -->
        <div class="history">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                    <HeadItemFour
                    @reGetList="reget()"
                    style="margin-top:8px;"
                    v-for="(item,index) in articleList"
                    :key="index"
                    :mes="item"
                    ></HeadItemFour>
            </van-list>
        </div>
        <div :style="'width:100%;height:'+screenHeight+'px;background-color:#E7E7E7;position:fixed;left:0;top:0;z-index:-1;'"></div>
        <BackTop></BackTop>
    </div>
</template>
<script>
let me;
import axios from 'axios';
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
import HeadItemFour from "../components/HeadItemFour";
import BackTop from "../components/BackTop";
export default {
    name:"mangerMyShop",
    data(){
        return{
            screenHeight:"",
            articleList:[],
            className:"",//用户输入的分类名称
            hasAddClassName:[],//已添加的分类
            shopId:"",
            page:1,
            finished: false,
            loading: false
        }
    },
    components:{
        HeadItemFour,
        BackTop
    },
    methods: {
        //跳转店铺信息详情页面
        goShopDetail() {
            me.$router.push({
                name:"shopDetailInfo",
                query:{
                    type:"goods",
                    id:me.shopId
                }
            })
        },
        back(){
            this.$router.go(-1);
        },
        goMangerMyShop(){
            // let url="http://jfc.jfbst.com/updateShopInfo?id="+me.shopId
            // window.location.href(url);
            this.$router.push({
                path:"updateShopInfo",
                query:{
                    id:me.shopId
                }
            })
        },
        searchClassName(){//列出分类
            getData('/shop/keywords',{
                "shop_id": me.shopId
            }).then(res=>{
                if(res.code==0){
                    me.hasAddClassName=res.data;
                }
            }).catch(err=>{

            })
        },
        deleteClassName(id){//删除分类
            let formData = new FormData();
            formData.append("keyword_id", id);
            postData("/shop/delete-keyword", formData, {
                headers: {
                "Content-Type": "multipart/form-data",
                "token": localStorage.getItem("token") != ""? localStorage.getItem("token"): "123456"
                }
            }).then(res => {
                    if(res.code==0){
                       me.searchClassName();
                    }
                }).catch(err => {
                    this.$toast("取消失败");
                });
        },
        confirmAdd(){//添加分类
            if(me.className.length<=0){
                this.$toast("分类名称不能为空！");
                return;
            }
            let formData=new FormData();
            formData.append("name",me.className);
            postData("/shop/keyword",formData,{
                headers: {
                "Content-Type": "multipart/form-data",
                "token": localStorage.getItem("token") != ""? localStorage.getItem("token"): "123456"
                }
            }).then(res=>{
                if(res.code==0){
                    me.className="";//类别置空
                    me.searchClassName();
                }
            }).catch(err=>{
                console.log(err);
            })
        },
        onLoad() {
            getData(
                "/shop/goods",
                {
                shop_id:me.shopId,
                category:0,
                page: this.page
                },
                {
                headers: {
                    token: localStorage.getItem("token")
                }
                }
            ).then(res => {
                this.loading = false;
                this.page++;
                if (res.data.length != 0) {
                res.data.map(a => {
                    this.articleList.push(a);
                });
                } else {
                this.finished = true;
                }
            });
        },
        reget() {
            this.articleList = [];
            this.page = 1;
            this.onLoad();
        },
    },
    mounted() {
        me=this;
        me.shopId=me.$route.query.shop_id;
        me.screenHeight=window.screen.availHeight;
        //me.onLoad();
        me.searchClassName();
    }
}
</script>
<style scoped>
.checkShopInfo {
    margin-top: 10px;
    display: flex;
    justify-content: center;
}
.checkShopInfo >div{
    padding: 5px 8px;
    background-color: #fff;
    border-radius: 5px;
    font-size: 13px;
    color: #7F47DD;
    font-weight: bold;
}
.history {
  padding: 10px 10px 5px;
  box-sizing: border-box;
}
.tips{
    width:92%;
    margin-left:4%;
    padding-top:11px;
    font-size:11px;
    padding-bottom:11px;
}
.tips>span:nth-child(1){
    color:#7F47DD;
}
.tips>span:nth-child(2){
    color:#D1D1D1;
}
.headInfo{
    width:96%;
    height:39.5px;
    margin-left:2%;
    background-color:#fff;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:18px;
    color:#000;
}
.headInfo>div{
    width:0;
    flex-grow:1;
}
.headInfo div:nth-child(1){
    font-size: 15px;
    color: gray;
}
.mangerInfo{
    width:100px;
    height:23.5px;
    border:1px solid #892785;
    border-radius:6px;
    font-size:13px;
    color:#892785;
    line-height:24px;
}
.addClass{
    width:344px;
    margin-left:15px;
    background-color:#fff;
    margin-top:2.5px;
    
}
.addClass>div:nth-child(1){
    font-size:18px;
    color:#000;
    text-align:left;
    padding-top:15px;
    padding-left:9px;
}
.addClass>div:nth-child(2){
    display:flex;
    width:317.5px;
    margin-left:11.5px;
    height:37px;
    border:1px solid #C1C1C2;
    border-radius:6px;
    justify-content:center;
    align-items:center;
    margin-top:10px;
}
.inputClass{
    width:223px;
    margin-left:2px;
    height:25px;
    border:none;
}
.outInputClass{
    border-right:1px solid #C1C1C2;
}
.confirmAdd{
    flex-grow: 1;
    font-size: 14px;
    color:#4D4D4D;
    padding: 0px 5px;;
}
.hasAddClass{
    width:92%;
    margin-left:4%;
    margin-top:7px;
    display:flex;
    flex-wrap:wrap;
}
.classList{
    margin-top:7px;
    margin-right:6px;
    height:23px;
    border:1px solid #C1C1C2;
    width: fit-content;
    display:flex;
    align-items:center;
    border-radius:6px;
}
.classList img{
    width:100%;
    height:100%;
}
.classList>div:nth-child(1){
    margin-left:10px;
    font-size:12px;
    color:#666666;
}
.classList>div:nth-child(2){
    position:relative;
    right:-5px;
    top:-15px;
    width:10.5px;
    height:10.5px;
}
</style>